import { createFileRoute } from "@tanstack/react-router";
import { OpacityUtilities } from "@/components/ui/examples/OpacityUtilities";

export const Route = createFileRoute(
  "/demo/design-system/theming/opacity-utilities",
)({
  component: OpacityUtilities,
});
